import React, { Component } from 'react';
import { ajaxWrapper, resolveVariables, format_date } from 'functions';

import QC_UCD_Downtown from 'pages/custom_forms/qc_ucd_downtown.js';
import QC_UCD_Anschutz from 'pages/custom_forms/qc_ucd_anschutz.js';
import Supervisor__Plugged_In_Scorecard from 'pages/custom_forms/supervisor__plugged_in_scorecard.js';
import Recruiters_Plugging_In_Scorecard from 'pages/custom_forms/recruiters_plugging_in_scorecard.js';
import Espanol_Plugging_In_Scorecard from 'pages/custom_forms/espanol_plugging_in_scorecard.js';
import Minnesota_1 from 'pages/custom_forms/minnesota_1.js';
import Hudson_Bay from 'pages/custom_forms/hudson_bay.js';
import Larimer_County from 'pages/custom_forms/larimer_county.js';
import _1700_Broadway from 'pages/custom_forms/_1700_broadway.js';
import Minnesota_2 from 'pages/custom_forms/minnesota_2.js';
import Haliburton from 'pages/custom_forms/haliburton.js';
import Michigan from 'pages/custom_forms/michigan.js';
import New_Mexico from 'pages/custom_forms/new_mexico.js';
import Northbelt from 'pages/custom_forms/northbelt.js';
import Schlumberger from 'pages/custom_forms/schlumberger.js';
import West_Texas from 'pages/custom_forms/west_texas.js';
import Lubbock_Animal_Kennel from 'pages/custom_forms/lubbock_animal_kennel.js';
import Employee_Recognition from 'pages/custom_forms/employee_recognition.js';
import Customer_Survey_Kleen_Tech from 'pages/custom_forms/customer_survey_kleen_tech.js';
import DO_Scorecard__Old from 'pages/custom_forms/do_scorecard__old.js';
import OM_Scorecard_Old from 'pages/custom_forms/om_scorecard_old.js';
import Foreman_Plugging_In_Scorecard from 'pages/custom_forms/foreman_plugging_in_scorecard.js';
import SNL_CA from 'pages/custom_forms/snl_ca.js';
import Customer_Survey_Sandia_National_Laboratory from 'pages/custom_forms/customer_survey_sandia_national_laboratory.js';
import Presidential_Hotline from 'pages/custom_forms/presidential_hotline.js';
import Centerpoint_Energy_Old from 'pages/custom_forms/centerpoint_energy_old.js';
import El_Paso_County from 'pages/custom_forms/el_paso_county.js';
import City_of_Lubbock from 'pages/custom_forms/city_of_lubbock.js';
import Centerpoint_Energy_North from 'pages/custom_forms/centerpoint_energy_north.js';
import Centerpoint_Energy_South from 'pages/custom_forms/centerpoint_energy_south.js';
import Centerpoint_Energy_TX from 'pages/custom_forms/centerpoint_energy_tx.js';

import _1700_Broadway_QC from 'pages/custom_forms/_1700_broadway_qc.js';
import West_Texas_QC from 'pages/custom_forms/west_texas_qc.js';
import Schlumberger_QC from 'pages/custom_forms/schlumberger_qc.js';
import Northbelt_QC from 'pages/custom_forms/northbelt_qc.js';
import Michigan_QC from 'pages/custom_forms/michigan_qc.js';
import Larimer_County_QC from 'pages/custom_forms/larimer_county_qc.js';
import Hudson_Bay_QC from 'pages/custom_forms/hudson_bay_qc.js';
import Haliburton_QC from 'pages/custom_forms/haliburton_qc.js';
import _2020_Director_of_Operations_Plugging_In_Scorecard from 'pages/custom_forms/_2020_director_of_operations_plugging_in_scorecard.js';
import _2020_Operations_Managers_Plugging_In_Scorecard from 'pages/custom_forms/_2020_operations_managers_plugging_in_scorecard.js';
import El_Paso_County_QC from 'pages/custom_forms/el_paso_county_qc.js';

import Test from 'pages/custom_forms/test.js';
import Colorado_5_UC_Denver_Anschutz from 'pages/custom_forms/colorado_5_uc_denver_anschutz.js';
import West_TX_Xcel_QC from 'pages/custom_forms/west_tx_xcel_qc.js';
import Xcel_NM_Hobbs from 'pages/custom_forms/xcel_nm_hobbs.js';

import Aurora_Carpet_QC from 'pages/custom_forms/aurora_carpet_qc.js';
import _2021_Director_of_Operations_Plugging_In_Scorecard from 'pages/custom_forms/_2021_director_of_operations_plugging_in_scorecard.js';
import _2021_Operations_Manager_Plugging_In_Scorecard from 'pages/custom_forms/_2021_operations_manager_plugging_in_scorecard.js';

import Minnesota_1_QC from 'pages/custom_forms/minnesota_1_qc.js';
import Minnesota_2_QC from 'pages/custom_forms/minnesota_2_qc.js';
import Minnesota_3_QC from 'pages/custom_forms/minnesota_3_qc.js';
import Minnesota_4_QC from 'pages/custom_forms/minnesota_4_qc.js';
import Minnesota_5_QC from 'pages/custom_forms/minnesota_5_qc.js';
import Minnesota_6_QC from 'pages/custom_forms/minnesota_6_qc.js';
import Minnesota_6_QC_CPE from 'pages/custom_forms/minnesota_6_qc_cpe.js';
import Minnesota_7_QC from 'pages/custom_forms/minnesota_7_qc.js';
import Minnesota_8_QC from 'pages/custom_forms/minnesota_8_qc.js';

import Minnesota_1_Checklists from 'pages/custom_forms/minnesota_1_checklists.js';
import Minnesota_2_Checklists from 'pages/custom_forms/minnesota_2_checklists.js';
import Minnesota_3_Checklists from 'pages/custom_forms/minnesota_3_checklists.js';
import Minnesota_4_Checklists from 'pages/custom_forms/minnesota_4_checklists.js';
import Minnesota_5_Checklists from 'pages/custom_forms/minnesota_5_checklists.js';

import OLD_Colorado_6_QC from 'pages/custom_forms/OLD_colorado_6_qc.js';
import OLD_Colorado_6_Checklists from 'pages/custom_forms/OLD_colorado_6_checklists.js';

import Colorado_1 from 'pages/custom_forms/colorado_1.js';
import Colorado_2 from 'pages/custom_forms/colorado_2.js';
import Colorado_3 from 'pages/custom_forms/colorado_3.js';

import Colorado_1_Checklists from 'pages/custom_forms/colorado_1_checklists.js';
import Colorado_2_Checklists from 'pages/custom_forms/colorado_2_checklists.js';
import Colorado_3_Checklists from 'pages/custom_forms/colorado_3_checklists.js';
import Colorado_5_Checklists from 'pages/custom_forms/colorado_5_checklists.js';
import Colorado_6_Checklists from 'pages/custom_forms/colorado_6_checklists.js';
import Colorado_7_Checklists from 'pages/custom_forms/colorado_7_checklists.js';
import Colorado_8_Checklists from 'pages/custom_forms/colorado_8_checklists.js';
import Colorado_9_Checklists from 'pages/custom_forms/colorado_9_checklists.js';
import Colorado_10_Checklists from 'pages/custom_forms/colorado_10_checklists.js';
import Colorado_11_Checklists from 'pages/custom_forms/colorado_11_checklists.js';
import Colorado_12_Checklists from 'pages/custom_forms/colorado_12_checklists.js';

import Colorado_1_QC from 'pages/custom_forms/colorado_1_qc.js';
import Colorado_2_QC from 'pages/custom_forms/colorado_2_qc.js';
import Colorado_3_QC from 'pages/custom_forms/colorado_3_qc.js';
import Colorado_4_QC from 'pages/custom_forms/colorado_4_qc.js';
import Colorado_5_QC from 'pages/custom_forms/colorado_5_qc.js';
import Colorado_6_QC from 'pages/custom_forms/colorado_6_qc.js';
import Colorado_7_QC from 'pages/custom_forms/colorado_7_qc.js';
import Colorado_8_QC from 'pages/custom_forms/colorado_8_qc.js';
import Colorado_9_QC from 'pages/custom_forms/colorado_9_qc.js';
import Colorado_10_QC from 'pages/custom_forms/colorado_10_qc.js';
import Colorado_11_QC from 'pages/custom_forms/colorado_11_qc.js';
import Colorado__12_QC from 'pages/custom_forms/colorado__12_qc.js';
import Colorado_6_QC_DIA from 'pages/custom_forms/colorado_6_qc_dia.js';
import Colorado_6_QC_DIA_Windows from 'pages/custom_forms/colorado_6_qc_dia_windows.js';

import Haliburton_Checklists from 'pages/custom_forms/haliburton_checklists.js';
import Hudson_Bay_Checklists from 'pages/custom_forms/hudson_bay_checklists.js';
import Larimer_County_Checklists from 'pages/custom_forms/larimer_county_checklists.js';
import Michigan_Checklists from 'pages/custom_forms/michigan_checklists.js';
import Northbelt_Checklists from 'pages/custom_forms/northbelt_checklists.js';
import Schlumberger_Checklists from 'pages/custom_forms/schlumberger_checklists.js';
import West_Texas_Checklists from 'pages/custom_forms/west_texas_checklists.js';
import Centerpoint_Energy_North_Checklists from 'pages/custom_forms/centerpoint_energy_north_checklists.js';
import Centerpoint_Energy_South_Checklists from 'pages/custom_forms/centerpoint_energy_south_checklists.js';
import El_Paso_County_Checklists from 'pages/custom_forms/el_paso_county_checklists.js';
import West_TX_Xcel_Checklists from 'pages/custom_forms/west_tx_xcel_checklists.js';
import Harris_County_Checklists from 'pages/custom_forms/harris_county_checklists.js';
import Lubbock_Checklists from 'pages/custom_forms/lubbock_checklists.js';
import City_Of_Lubbock_QC from 'pages/custom_forms/city_of_lubbock_qc.js';
import Douglas_County_Checklists from 'pages/custom_forms/douglas_county_checklists.js';
import Florida_1_QC from 'pages/custom_forms/florida_1_qc.js';
import Florida_2_QC from 'pages/custom_forms/florida_2_qc.js';
import Florida_1_Checklists from 'pages/custom_forms/florida_1_checklists.js';
import Florida_2_Checklists from 'pages/custom_forms/florida_2_checklists.js';
import PA_Division_1_QC from 'pages/custom_forms/pa_division_1_qc.js';
import PA_Division_2_QC from 'pages/custom_forms/pa_division_2_qc.js';
import PA_Division_3_QC from 'pages/custom_forms/pa_division_3_qc.js';
import PA_Division_4_QC from 'pages/custom_forms/pa_division_4_qc.js';
import PA_Division_5_QC from 'pages/custom_forms/pa_division_5_qc.js';
import PA_Division_6_QC from 'pages/custom_forms/pa_division_6_qc.js';
import UCD_Downtown_Checklists from 'pages/custom_forms/ucd_downtown_checklists.js';
import UCD_Anschutz_Checklists from 'pages/custom_forms/ucd_anschutz_checklists.js';
import Larimer_County_Numeric from 'pages/custom_forms/larimer_county_numeric.js';

import Sentinal_Austin_QC from 'pages/custom_forms/sentinel_austin_qc.js';
import Sentinal_Austin_Checklist from 'pages/custom_forms/sentinel_austin_checklist.js';
import Sentinal_Nevada_Checklist from 'pages/custom_forms/sentinel_nevada_checklist.js';

import Houston_Airport_System_QC from 'pages/custom_forms/houston_airport_system_qc.js';
import Houston_Airport_System_Checklist from 'pages/custom_forms/houston_airport_system_checklist.js';

import INVALID_Illinois_1_QC from 'pages/custom_forms/INVALID_illinois_1_qc.js';
import INVALID_Illinois_2_QC from 'pages/custom_forms/INVALID_illinois_2_qc.js';
import INVALID_Illinois_3_QC from 'pages/custom_forms/INVALID_illinois_3_qc.js';

import Illinois_1_QC from 'pages/custom_forms/illinois_1_qc.js';
import Illinois_2_QC from 'pages/custom_forms/illinois_2_qc.js';
import Illinois_3_QC from 'pages/custom_forms/illinois_3_qc.js';
import Illinois_4_QC from 'pages/custom_forms/illinois_4_qc.js';

import Indiana_1_QC from 'pages/custom_forms/indiana_1_qc.js';
import Indiana_1_CPE_QC from 'pages/custom_forms/indiana_1_cpe_qc.js';

import OLD_SC_QC_1 from 'pages/custom_forms/old_sc_qc_1.js';
import SC_QC_1 from 'pages/custom_forms/sc_qc_1.js';
import SC_QC_2 from 'pages/custom_forms/sc_qc_2.js';

import Northeast_and_Nevada_QC from 'pages/custom_forms/northeast_and_nevada_qc.js';

import California_1_QC from 'pages/custom_forms/california_1_qc.js';
import California_2_QC from 'pages/custom_forms/california_2_qc.js';
import California_3_QC from 'pages/custom_forms/california_3_qc.js';
import California_5_QC from 'pages/custom_forms/california_5_qc.js';
import PA_District_3_Checklist from 'pages/custom_forms/pa_district_3_checklist.js';

import Harris_County_QC from 'pages/custom_forms/harris_county_qc.js';
import HCTRA_QC from 'pages/custom_forms/HCTRA_qc.js';
import SNL_QC from 'pages/custom_forms/snl_qc.js';

import QC_Florida_1_Residential from 'pages/custom_forms/qc_florida_1_residential.js';
import QC_Florida_2_Residential from 'pages/custom_forms/qc_florida_2_residential.js';

import Sonoran_East_Valley from 'pages/custom_forms/sonoran_east_valley.js';
import Sonoran_Northwest_Valley from 'pages/custom_forms/sonoran_northwest_valley.js';
import PA_District_6_QC from 'pages/custom_forms/pa_district_6_qc.js';
import NC_QC from 'pages/custom_forms/nc_qc.js';

import MI_QC from 'pages/custom_forms/mi_qc.js';

function custom_form_lookup(id) {
    console.log('\n\n\nCustom Form Lookup!', id);
    var content = null;

    if (!id) {
        return null;
    }
    //Customer Survey - Sandia National Laboratory
    else if (id == '88fccc5e-92a6-4bc9-8947-e5bd0fa1b8a4') {
        content = Customer_Survey_Sandia_National_Laboratory();
    }
    //Presidential Hotline
    else if (id == '9b660769-da87-4288-917f-822fae556190') {
        content = Presidential_Hotline();
    }
    //QC - California 1
    else if (id == '6de034a9-4692-42e0-b6b4-8f70b3b4feb7') {
        content = California_1_QC();
    }
    //QC - California 2
    else if (id == 'dfbe84f8-6478-4c90-84c5-472129bac11e') {
        content = California_2_QC();
    }
    //QC - California 3
    else if (id == '1d53ca7a-d9d6-4e89-ac4b-508cf3541c00') {
        content = California_3_QC();
    }
    //QC - California 5
    else if (id == '44062282-8301-466a-b502-689bae1675c4') {
        content = California_5_QC();
    }
    //QC - CenterPoint Energy
    else if (id == '42cf90b7-4a15-4c0d-8d78-2c800f88e083') {
        content = Centerpoint_Energy_North();
    }
    //QC - CenterPoint Energy TX
    else if (id == 'f348f6f7-e2b4-4773-ac73-44e8b40ea60b') {
        content = Centerpoint_Energy_TX();
    }
    //QC - City of Lubbock
    else if (id == '6210a0ac-7feb-4bba-9cb6-8a9385bf36a8') {
        content = City_Of_Lubbock_QC();
    }
    //QC - Colorado #1
    else if (id == 'eb0c853e-573f-47f0-afff-f318346ef185') {
        content = Colorado_1_QC();
    }
    //QC - Colorado #2
    else if (id == 'ae3d9ab1-ad09-4518-9dc6-dbb42e718541') {
        content = Colorado_2_QC();
    }
    //QC - Colorado #3
    else if (id == '48b96ebb-1ccb-4c83-8d28-25a53875896d') {
        content = Colorado_3_QC();
    }
    //QC - Colorado #4
    else if (id == '422c20fc-5a26-4411-b285-753c995a0a5c') {
        content = Colorado_4_QC();
    }
    //QC - Colorado #6 Windows
    else if (id == 'bd6ba771-3178-48c2-93f5-4f2238520cf7') {
        content = Colorado_6_QC_DIA_Windows();
    }
    //QC - Colorado #6 DIA Glass
    else if (id == '889c9e99-3e08-46eb-9b7c-9d605acc7a38') {
        content = Colorado_6_QC_DIA();
    }
    //QC - Colorado #6 DIA Windows
    else if (id == '8b816803-7e0a-4ae1-9c85-224571ea7670') {
        content = Colorado_6_QC_DIA_Windows();
    }
    //QC - Colorado #7
    else if (id == '0a18b1d5-e53d-4daa-bac8-1a9ba2b12bb6') {
        content = Colorado_7_QC();
    }
    //QC - Florida #1
    else if (id == '87fbf3f7-8f67-4891-86b4-5819fb7963bf') {
        content = Florida_1_QC();
    }
    //QC - Florida #2
    else if (id == 'f8ccd6ea-75b1-4120-849e-42d3858dcf21') {
        content = Florida_2_QC();
    }
    //QC - Florida 1 Residential
    else if (id == 'd9a8395d-c5d0-4823-8275-4da4934643f4') {
        content = QC_Florida_1_Residential();
    }
    //QC - Florida 2 Residential
    else if (id == '70a1e5b5-4c76-4d92-a990-65d3d7ef5529') {
        content = QC_Florida_2_Residential();
    }
    //QC - Haliburton
    else if (id == 'feb71a5f-148f-403a-a5a7-59f8732aa0b2') {
        content = Haliburton_QC();
    }
    //QC - Houston Airport System
    else if (id == 'a0c0de51-17e6-4539-a805-9441a82c956b') {
        content = Houston_Airport_System_QC();
    }
    //QC - Illinois 1
    else if (id == '7badc8d3-2065-4d8b-accd-5d3de3fdae8b') {
        content = Illinois_1_QC();
    }
    //QC - Illinois 2
    else if (id == '52d76bf6-65b1-4182-bd8a-9dd526ce3640') {
        content = Illinois_2_QC();
    }
    //QC - Illinois 3
    else if (id == 'cf22a929-7f83-4f6c-ac2e-a307d9c45979') {
        content = Illinois_3_QC();
    }
    //QC - Minnesota #1
    else if (id == '125525d6-f4ea-42c2-b830-63f59d49d55b') {
        content = Minnesota_1_QC();
    }
    //QC - Minnesota #3
    else if (id == '1e5a351d-d560-4413-aaac-20abd3e2c200') {
        content = Minnesota_3_QC();
    }
    //QC - Minnesota #4
    else if (id == '050e89a3-be45-4959-90cc-2f1d1ebf6286') {
        content = Minnesota_4_QC();
    }
    //QC - Minnesota #5
    else if (id == 'c9e9ca6d-ae62-4208-9f1b-a05c39bf7290') {
        content = Minnesota_5_QC();
    }
    //QC - Minnesota #6
    else if (id == '8682c2a9-fe70-49b1-87ed-b0b4420cb93e') {
        content = Minnesota_6_QC();
    }
    //QC - Minnesota #6 CPE
    else if (id == '334e4c6d-0117-42fd-883c-3065d9b09ce1') {
        content = Minnesota_6_QC_CPE();
    }
    //QC - Minnesota #7
    else if (id == 'aff6d3a7-e815-48e1-9f25-d9ca68f1bc55') {
        content = Minnesota_7_QC();
    }
    //QC - Minnesota #8
    else if (id == 'f134ea5e-687b-40a5-b0f9-3f5deea66208') {
        content = Minnesota_8_QC();
    }
    //QC - Michigan #1
    else if (id == 'd759375b-1320-4aa4-83be-7d71452b1c6f') {
        content = Minnesota_2_QC();
    }
    //QC - NC
    else if (id == 'aa1ddfad-9285-4fe4-953f-9b59c6cb641e') {
        content = NC_QC();
    }
    //QC - Northbelt
    else if (id == 'cf1b5b78-176e-4d4a-8298-217732a9c465') {
        content = Northbelt_QC();
    }
    //QC - Northeast
    else if (id == '3ea7e645-d401-4932-9666-ca6d2c8a0952') {
        content = Northeast_and_Nevada_QC();
    }
    //QC - PA District 5
    else if (id == 'f2c03aa6-005e-459b-b4a1-b9878fff6bef') {
        content = PA_Division_5_QC();
    }
    //QC - Sentinel Austin
    else if (id == '3896b858-a5fe-4e48-b6de-d66274939d2d') {
        content = Sentinal_Austin_QC();
    }
    //QC - UCD Anschutz
    else if (id == '6672bcd0-7294-4db5-9eef-e730969cf461') {
        content = QC_UCD_Anschutz();
    }
    //QC - UCD Downtown
    else if (id == '323d950b-967f-4f4f-84aa-f574aba0fb9c') {
        content = QC_UCD_Downtown();
    }
    //QC SNL/CA
    else if (id == '0601a3c0-bca1-4b8e-b241-4befcc22c795') {
        content = SNL_QC();
    }
    //QC – HCTRA
    else if (id == '205a40dd-ba9a-4ee7-8604-ac74b3e7f98c') {
        content = HCTRA_QC();
    }
    //QC – Indiana #1
    else if (id == 'a0f044b0-5d23-4f54-ad00-da9d56560146') {
        content = Indiana_1_QC();
    }
    //QC – Indiana #1 CPE
    else if (id == 'a551f316-7d7b-47dc-a683-78f395eaddb9') {
        content = Indiana_1_CPE_QC();
    }
    //QC – PA District 1
    else if (id == 'ee821756-5869-483b-a8a5-28a8f2f30813') {
        content = PA_Division_1_QC();
    }
    //QC – PA District 2
    else if (id == '39ae2136-f32e-4f39-ae06-e0a9223138ef') {
        content = PA_Division_2_QC();
    }
    //QC – PA District 3
    else if (id == '37646c89-8166-4994-93a7-ad11fc04149d') {
        content = PA_Division_3_QC();
    }
    //QC – PA District 4
    else if (id == 'ed7a864b-e496-4aa4-bf87-0dd14e1cde94') {
        content = PA_Division_4_QC();
    }
    //QC – PA District 6
    else if (id == 'aedb24d9-b6b3-49e7-92b3-b15565387f39') {
        content = PA_Division_6_QC();
    }
    //QC – SC1
    else if (id == '69e2ea5c-3982-409b-9e6d-b186f8538f76') {
        content = SC_QC_1();
    }
    //QC – SC2
    else if (id == '131d648a-ed3e-4526-bc7f-ed30dd1f1b7b') {
        content = SC_QC_2();
    }
    //Sonoran – Northwest Valley
    else if (id == 'f48f2d10-7558-41f1-86f9-45821e29174a') {
        content = Sonoran_Northwest_Valley();
    }
    //Test
    else if (id == '089162d6-6e9c-4647-a178-aab73d6d43dc') {
        content = Test();
    }

    return content;
}

export default custom_form_lookup;
